import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { openSubmissionsConfigReducer } from './configuration/reducer';
import { OpenSubmissionsWidgetState } from './OpenSubmissionsWidgetState';
import { OpenSubmissionsActionPayload } from './actions';
import { openSubmissionsStreamReducer } from './stream/reducer';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';

const widgetStateReducer = combineReducers<OpenSubmissionsWidgetState>({
    stream: openSubmissionsStreamReducer,
    config: openSubmissionsConfigReducer,
});

export const openSubmissionsWidgetsReducer = createWidgetsReducer<
    OpenSubmissionsWidgetState,
    OpenSubmissionsActionPayload
>(WidgetType.OPEN_SUBMISSIONS, widgetStateReducer);
